import { app } from '../resources/gcp-config';
import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
} from 'firebase/firestore';

const db = getFirestore(app);

// Fetch all sent email data with real-time updates
export const fetchAllSentEmailData = (callback) => {
  const emailCollectionRef = collection(db, 'sent-emails');
  return onSnapshot(emailCollectionRef, (querySnapshot) => {
    const emails = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      docId: doc.id,
    }));
    callback(emails);
  });
};

// Fetch a single sent email record by its document ID
export const fetchSingleSentEmailData = (docId, onUpdate) => {
  const emailDocRef = doc(db, 'sent-emails', docId);
  const unsubscribe = onSnapshot(
    emailDocRef,
    (docSnap) => {
      if (docSnap.exists()) {
        const emailData = {
          ...docSnap.data(),
          docId: docSnap.id,
        };
        onUpdate(emailData);
      } else {
        console.log("No such document!");
      }
    },
    (error) => console.error(`Error fetching document: ${error}`)
  );

  return unsubscribe;
}; 